<template>
  <div class="col-12 sector invoice-sector px-3">
    <div class="row">
      <div class="sector__header">
      	商品金額：{{ state.currency_symbol }} {{ insuranceAssortRawTotal }}
      </div>
      
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'
import { currencyFormat, dataTranslations as dt } from "../../utils"

const props = defineProps({
  form: Object,
  state: Object,
  insuranceAssortRawTotal: Number,
  insuranceFees: Number,
})
const emit = defineEmits(['update:form'])

const { t, locale } = useI18n()
const form = useVModel(props, 'form', emit)

</script>
